import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const NotificationActiveIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue7f7'}</MuiIcon>
        );
    })
